import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=0793267a&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=0793267a&prod&lang=scss"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=0793267a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0793267a",
  null
  
)

export default component.exports